import { render } from "./DeployVM.vue?vue&type=template&id=bf80b29e&scoped=true"
import script from "./DeployVM.vue?vue&type=script&lang=js"
export * from "./DeployVM.vue?vue&type=script&lang=js"

import "./DeployVM.vue?vue&type=style&index=0&id=bf80b29e&lang=less&scoped=true"
import "./DeployVM.vue?vue&type=style&index=1&id=bf80b29e&lang=less"

import exportComponent from "/root/mold/diplo/dist/rpmbuild/BUILD/cloudstack-4.21.0.0-Diplo-202603161407/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf80b29e"]])

export default __exports__